class API
{
    static localBaseAddress: string = "http://localhost:5001/eta-backend/us-central1/api/";
    // static localBaseAddress: string = "http://localhost:5001/eta-backend/us-central1/api/";
    static baseAddress: string = "https://europe-west3-eta-backend.cloudfunctions.net/api/";
}

export default API;